import { random } from "lodash";

function randomElement(options) {
  return options.length > 0 ? options[random(0, options.length - 1)] : null;
}

function randomString() {
  return randomElement(["xyz", "Иванов", "Пётр Первый", "1234", "945-999-99-99", "f@#%*", ""]);
}

function markElements(arr) {
  return arr.map((element, index) => ({ mark: index, value: element }));
}

function pickRandomOptionOfCollection(subforms) {
  const options = markElements(subforms.map(pickRandomOption));
  const nonEmptyOptions = options.filter(({ value }) => value !== null);
  return randomElement(nonEmptyOptions);
}

/**
 * Pick random option (move) for given form.
 *
 * If the `form` implies no move, `null` is returned.
 *
 * @param {Form} form - a form that specifies a set of possible moves.
 * @return {*} a random option (move) that corresponds to the form.
 */
export default function pickRandomOption(form) {
  switch(form.type) {
    case "ActionButton":
    case "InputOption":
      return undefined;
    case "InputString": return randomString();
    case "SectionForm":
      return pickRandomOptionOfCollection(form.subforms);
    case "SumForm":
      return pickRandomOptionOfCollection(form.subforms);
    case "SumSubj":
      return pickRandomOptionOfCollection(form.forms);
    case "LockedForm":
    case "TextForm":
    case "EmptyForm":
    case "HTMLElementForm":
    case "ListingForm":
      return null;
    case "TimeForm":
    case "MessageForm":
    case "WorkingAreaUnformatted":
    case "Cell":
    case "FramedForm":
    case "LabeledForm":
    case "LabeledWithForm":
    case "MathJaxed":
      return pickRandomOption(form.form);
    case "ApplicationForm":
      return updateTables(form.datas);
    case "cmd":
      return {};
  }
  throw new Error(form.type + " is not supported by pickRandomOption");
  return undefined;
};

function updateTables(datas){
  let newTables = {};
  const keys = [
    "tbl-1-1", "tbl-1-2", "tbl-1-3", "tbl-1-4", "tbl-1-5", "tbl-1-6-1", "tbl-1-6-2", "tbl-1-7", 
    "tbl-2-1", "tbl-2-2-1", "tbl-2-2-2", "tbl-2-2-3", "tbl-2-3-1", "tbl-2-3-2", "tbl-2-3-3", "tbl-2-4-1", 
    "tbl-2-4-2", "tbl-5-1", "tbl-5-2", "tbl-5-3",
  ];
  for(let i = 0; i < keys.length; i++){
    newTables[keys[i]] = {};
    newTables[keys[i]].leftEmpty = false;
    if(datas[keys[i]]){
      if(Array.isArray(datas[keys[i]])){
        newTables[keys[i]].data = datas[keys[i]];
      }
      else {
        newTables[keys[i]] = datas[keys[i]];
      }
      
    }
    else {
      newTables[keys[i]].data = [];
    }
  }
  return newTables;
}
